module.exports = __webpack_public_path__ + "img/41.1a007d3b.jpg";